import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ViewCategory } from '@ddt-web/config';
import { first } from 'rxjs/operators';

import { AudienceService } from '../services/audience.service';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[showOnlyInView]' })
export class ShowOnlyInViewDirective implements OnInit {
	@Input('showOnlyInView') public viewCategories: Array<ViewCategory>;
	private currentViewCategoryType: ViewCategory;
	constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, public audienceService: AudienceService) { }

	public ngOnInit(): void {
		this.getViewCategory();
	}

	private initEmbeddedView(): void {
		if (this.viewCategories && this.currentViewCategoryType) {
			let match: boolean = true;
			if (!this.viewCategories.includes(this.currentViewCategoryType)) {
				match = false;
			}

			this.viewContainer.clear();
			if (match) {
				this.viewContainer.createEmbeddedView(this.templateRef);
			}
		} else {
			this.viewContainer.clear();
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}

	public getViewCategory(): void {
		this.audienceService.getViewCategory()
			.pipe(
				first()
			)
			.subscribe((viewCategory: ViewCategory) => {
				if (this.currentViewCategoryType !== viewCategory) {
					this.currentViewCategoryType = viewCategory;
					this.initEmbeddedView();
				}
			});
	}
}
